<template>
    <Layout :noFoot="true">
        <div slot="main" class="main-coop">
            <nav class="back-nav">
                <div class="back-icon" @click="goBack">
                    <img :src="back" alt="">
                </div>
            </nav>
            <form v-show="!isSuccess" class="coop-form" action="">
                <div class="form-title">{{lang.coop}}</div>
                <div class="form-row">
                    <span class="form-line"></span>
                    <span class="form-label">{{lang.coopBusiness}}</span>
                    <span class="form-input">
                        <input v-model="business" class="input-text" type="text" readonly @click="openChoose" />
                    </span>
                </div>
                <div class="form-row">
                    <span class="form-line"></span>
                    <span class="form-label">{{lang.coopCompany}}</span>
                    <span class="form-input">
                        <input v-model="company" class="input-text" type="text" maxlength="100" />
                    </span>
                </div>
                <div class="form-row">
                    <span class="form-line"></span>
                    <span class="form-label">{{lang.coopCity}}</span>
                    <span class="form-input">
                        <input v-model="city" class="input-text" type="text" maxlength="50" />
                    </span>
                </div>
                <div class="form-row">
                    <span class="form-line"></span>
                    <span class="form-label">{{lang.coopName}}</span>
                    <span class="form-input">
                        <input v-model="name" class="input-text" type="text" maxlength="50" />
                    </span>
                </div>
                <div class="form-row">
                    <span class="form-line"></span>
                    <span class="form-label">{{lang.coopPhone}}</span>
                    <span class="form-input">
                        <input v-model="phone" class="input-text" type="text" maxlength="20" />
                    </span>
                </div>
                <div class="form-row">
                    <span class="form-line"></span>
                    <span class="form-label">{{lang.coopEmail}}</span>
                    <span class="form-input">
                        <input v-model="email" class="input-text" type="text" maxlength="50" />
                    </span>
                </div>
                <div class="submit-row">
                    <span class="form-submit" @click="submit">{{lang.submit}}</span>
                </div>
            </form>
            <div v-show="isSuccess" class="success-page">
                <div class="form-title">{{lang.coop}}</div>
                <div class="tips-content">{{lang.coopSuccess}}</div>
                <div class="return-row">
                    <span class="form-submit" @click="goBack">{{lang.ok}}</span>
                </div>
            </div>
            <q-dialog v-model="chooseSwitch" position="bottom">
                <div class="choose-area">
                    <img class="close-choose" src="../../style/image/close_select.png" alt="" @click="chooseSwitch = false">
                    <div class="vw-item-area">
                        <span
                            v-for="(business, index) in itemClass"
                            :key="index"
                            :class="['vw-item', business.style]"
                            @click="toggleItem(index)"
                        >
                            {{business.name}}
                        </span>
                    </div>
                </div>
            </q-dialog>
        </div>
    </layout>
</template>

<script>
import backSrc from '@/style/image/back.png';
import getLang from '@/utils/main/lang';
import Layout from '@/views/Layout.vue';
import ajax from '@/utils/ajax';
import validate from '@/utils/validate';
import router from '@/router';

export default {
    name: 'home',
    components: {
        Layout,
    },
    data() {
        return {
            isCn: window.localStorage.getItem('show-lang') !== 'en',
            back: backSrc,
            lang: getLang(),
            isSuccess: false,
            canChoose: true,
            chooseSwitch: false,
            business: '',
            company: '',
            city: '',
            name: '',
            phone: '',
            email: '',
            itemClass: [],
        };
    },
    mounted() {
        const self = this;
        this.business = this.$route.query ? this.$route.query.business : '';
        this.canChoose = !this.business;
        ajax.get('/web/business/business_list.json', {
            pageSize: 1000,
            page: 1,
        }).then((result) => {
            this.itemClass = result.dataList.map((v) => {
                const name = self.isCn ? v.cnBusinessName : v.enBusinessName;
                return {
                    style: '',
                    name,
                };
            });
        }).catch(() => {});
    },
    methods: {
        goBack() {
            router.go(-1);
        },
        openChoose() {
            if (this.canChoose) {
                this.chooseSwitch = true;
            }
        },
        toggleItem(index) {
            this.itemClass[index].style = this.itemClass[index].style ? '' : 'active';
            const business = [];
            this.itemClass.map((v) => {
                if (v.style) {
                    business.push(v.name);
                }
                return v;
            });
            this.business = business.join(',');
        },
        submit() {
            if (validate.judge(this.business, 'require') !== true) {
                this.$q.dialog({ title: this.lang.inputBusiness, message: '' });
            } else if (validate.judge(this.company, ['require']) !== true) {
                this.$q.dialog({ title: this.lang.inputCompany, message: '' });
            } else if (validate.judge(this.city, ['require']) !== true) {
                this.$q.dialog({ title: this.lang.inputBirthday, message: '' });
            } else if (validate.judge(this.name, ['require']) !== true) {
                this.$q.dialog({ title: this.lang.inputName, message: '' });
            } else if (validate.judge(this.phone, ['require']) !== true) {
                this.$q.dialog({ title: this.lang.inputPhone, message: '' });
            } else if (validate.judge(this.phone, ['number']) !== true) {
                this.$q.dialog({ title: this.lang.realPhone, message: '' });
            } else if (validate.judge(this.email, ['require']) !== true) {
                this.$q.dialog({ title: this.lang.inputEmail, message: '' });
            } else {
                ajax.post('/web/common/partner_save.json', {
                    businessNames: this.business,
                    company: this.company,
                    city: this.city,
                    name: this.name,
                    phone: this.phone,
                    email: this.email,
                }).then(() => {
                    this.isSuccess = true;
                }).catch((info) => {
                    this.$q.dialog({ title: '', message: info.message });
                });
            }
        },
    },
};
</script>
<style lang="less" scoped>
    .main-coop {
        position: fixed;
        top: 50px;
        bottom: 0;
        left: 0;
        width: 100%;
        background: url('../../style/image/coop_back.png') 50% 50% no-repeat rgba(0,0,0,.65);
        background-size: cover;
        overflow: auto;
    }
    .back-nav {
        width: 100%;
        height: 44px;
        background: #fff;
        display: flex;
        justify-content: space-between;
        align-content: center;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 3;
        .back-icon {
            width: 11px;
            height: 17px;
            margin-top: 14px;
            margin-left: 20px;
            img {
                width: 100%;
                height: 100%;
            }
        }
    }
    .coop-form {
        width: 284px;
        margin: 0 auto;
        padding-right: 22px;
    }
    .form-title {
        font-size: 18px;
        font-weight: 600;
        color: #fff;
        text-align: center;
        padding: 68px 0 52px;
    }
    .form-row {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        height: 40px;
        margin-bottom: 12px;
    }
    .form-line {
        display: inline-block;
        margin-right: 3px;
        width: 2px;
        height: 12px;
        background: #C71F4B;
    }
    .form-label {
        flex: 0 0 90px;
        padding-left: 4px;
        color: #fff;
        font-size: 13px;
        font-weight: 500;
        line-height: 18px;
        word-break: break-word;
    }
    .form-input {
        width: 165px;
        .input-text {
            background: transparent;
            border: 1px solid rgba(255,255,255,0.65);
            height: 24px;
            line-height: 24px;
            padding: 0 7px;
            color: #fff;
        }
    }
    .return-row {
        padding-top: 75px;
        text-align: center;
        .form-submit {
            display: inline-block;
            width: 165px;
            height: 34px;
            line-height: 34px;
            color: #fff;
            font-size: 15px;
            font-weight: 600;
            background: #C71F4B;
        }
    }
    .submit-row {
        padding-top: 75px;
        padding-bottom: 25px;
        text-align: center;
        .form-submit {
            display: inline-block;
            width: 165px;
            height: 34px;
            line-height: 34px;
            color: #fff;
            font-size: 15px;
            font-weight: 600;
            background: #C71F4B;
        }
    }
    .return-row {
        padding-bottom: 40px;
    }
    .success-page {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    .tips-content {
        color: #fff;
        font-size:13px;
        font-weight: 600;
        text-align: center;
    }
    .choose-area {
        background: #fff;
        position: relative;
        padding-top: 25px;
        .close-choose {
            position: absolute;
            top: 20px;
            right: 15px;
            width: 10px;
            height: 10px;
        }
    }

    .vw-item-area {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        padding: 15px;
        .vw-item {
            margin: 8px 12px;
            padding: 5px 6px;
            line-height: 12px;
            border: 1px solid #C1C1C1;
            color: #C1C1C1;
            font-size: 12px;
            &.active {
                color: #C71F4B;
                border-color: #C71F4B;
            }
        }
    }
</style>
